import CircularProgress from "@mui/material/CircularProgress";
import MDButton from "components/MDButton";
import PropTypes from "prop-types";

const LoadingButton = (props) => {
  const { loading, progressColor, children, ...rest } = props;
  return (
    <MDButton {...rest} disabled={loading}>
      {loading && <CircularProgress size={20} color={progressColor} />}
      {!loading && children}
    </MDButton>
  );
};

LoadingButton.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  loading: PropTypes.bool,
  color: PropTypes.string,
  progressColor: PropTypes.string,
  variant: PropTypes.string,
};

LoadingButton.defaultProps = {
  loading: false,
  color: "primary",
  progressColor: "inherit",
  variant: "contained",
};

export default LoadingButton;
